import React, { useState, useContext } from 'react';
import { getIcon, getStateIcon, getDetailsIcon } from '../../../utils/images';
import { getStateColorMap } from '../../../utils/utils';
import ShipmentListCardOptions from '../../ShipmentList/ShipmentListCardOptions/ShipmentListCardOptions';
import TrackBig from '../../TrackBig/TrackBig';
import './ShipmentDetailsHeader.scss';
import { getShareUrl } from '../../../services/user';
import { useCopyToClipboard } from 'usehooks-ts';
import { message, Tooltip } from 'antd';
import NowlunFormContext from '../../../context/NowlunFormContext';

const ShipmentDetailsHeader = ({ shipment, clearSelectedShipment, refetch, readableOnly }) => {
  const [value, copy] = useCopyToClipboard();
  const [shipmentOptionsOpened, setShipmentOptionsOpened] = useState(null);
  const { setShowEditNowlunForm } = useContext(NowlunFormContext);

  const handleCloseClicked = () => {
    document.getElementsByClassName('wrapper-open')[0].classList.add('wrapper-close');
    setTimeout(() => clearSelectedShipment(), 1000);
  };

  const handleShowNowlunForm = (shipment) => {
    handleCloseClicked();
    setShowEditNowlunForm(shipment);
  };

  async function handleShareShipment() {
    const resp = await getShareUrl({ shipment_id: shipment.id });
    copy(`${process.env.REACT_APP_ROOT_HOST}${resp.data.url}`);
    message.success('Share URL copied to clipboard');
  }

  return (
    <div className="ShipmentDetailsHeader">
      <div className="header__background"></div>
      <div className="header__top header__left">
        <img src={getIcon('close')} onClick={handleCloseClicked} />
        {(shipment.booking_number || shipment.bl) &&
          <div className="booking">#{shipment.booking_number || shipment.bl}</div>}
        {shipment.client_ref && <div className="booking">{shipment.client_ref}</div>}
        {shipment.shipping_line && <div className="line">{shipment.shipping_line?.name}</div>}
        {shipment.company && <div className="line">{shipment.company}</div>}
      </div>
      <div className="header__top header__right">
        <Tooltip title="Click to copy share URL">
          <img src={getIcon('share-shipment')} onClick={handleShareShipment} alt="Share Shipment" />
        </Tooltip>
        <ShipmentListCardOptions
          shipment={shipment}
          refetch={refetch}
          shipmentOptionsOpened={shipmentOptionsOpened}
          setShipmentOptionsOpened={setShipmentOptionsOpened}
          onShowNowlunForm={handleShowNowlunForm}
          readableOnly={readableOnly}
        />
      </div>
      <div className="state">
        <div className="state__icon"><img src={getStateIcon(shipment.state)} /></div>
        <div className="state__title">{getStateColorMap(shipment.state).title}</div>
        {shipment.empty_returned_at || shipment.gated_out_at ? (
          <div className="state__gateout">
            {shipment.empty_returned_at && <span>{`Empty return: ${shipment.empty_returned_at}\n`}</span>}
            {shipment.gated_out_at && <span>{`Gated out: ${shipment.gated_out_at}`}</span>}
          </div>
        ) : null}
      </div>
      <div className="containers">
        <img src={getDetailsIcon('containers')} />
        {shipment.cargo}
      </div>
      <TrackBig shipment={shipment} />
    </div>
  );
};

export default ShipmentDetailsHeader;
